import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import PatreonConfirmation from 'components/user/patreon_confirmation';
import Text from 'components/text';
import Stack from 'components/layout/stack';

@observer
class SettingsPatreon extends React.Component {

  render() {
    return (
      <Stack gap='sm'>
        <Text heading='3'>
          Patreon Connection
        </Text>
        <PatreonConfirmation
          showRemoveLink
        />
      </Stack>
    );
  }
}

export default ErrorBoundary(SettingsPatreon);
